// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-unused-vars */
// import { post } from "./utils";
import request from "./request";
import { CHANNEL_SERVER } from "./constants";

export type UserInfo = { name: string; rtcUID: number; avatarURL: string };

export enum ListChannelsType {
    /**
     * 我创建的
     */
    CREATED = "created",
    /**
     * 我加入的
     */
    JOINED = "joined",
}

export interface QueryChannelResult {
    code: string;
    msg: string;
    data: QueryChannelResultData[];
}

export interface QueryChannelResultData {
    id: number;
    createTime: string;
    updateTime: string;
    channelUuid: string;
    ownerUuid: string;
    channelName: string;
    beginTime: any;
    endTime: any;
    isDelete: number;
    maxPlayer: number;
    timeInterval: number;
    inviteFlag: string;
}

export const getSelfCreatedChannels = async (uid: string): Promise<QueryChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/list?ownerUuid=" + uid,
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export const getJoinedChannels = async (uid: string): Promise<QueryChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/joined?userId=" + uid,
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface CreateChannelPayload {
    channelName: string;
}

export interface CreateChannelResult {
    code: string;
    msg: string;
    data: string;
}

export const createChannel = async (
    payload: CreateChannelPayload,
): Promise<CreateChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/add",
        method: "post",
        data: payload,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface UpdateChannelResult {
    code: string;
    msg: string;
    data: any;
}

export interface UpdateChannelPayload {
    channelName: string;
    channelUuid: string;
    timeInterval?: number;
    maxPlayer?: number;
}

export const updateChannel = async (data: UpdateChannelPayload): Promise<UpdateChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/update",
        method: "post",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface DeleteChannelPayload {
    channelUuid: string;
}

export interface DeleteChannelResult {
    code: string;
    msg: string;
    data: any;
}

export const deleteChannel = async (data: DeleteChannelPayload): Promise<DeleteChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/delete",
        method: "post",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export const deleteJoinedChannel = async (
    data: DeleteChannelPayload,
): Promise<DeleteChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/deleteJoined",
        method: "post",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface EnterQuitChannelPayload {
    channelUuid: string;
    inChannelStatus: number;
}

export interface EnterQuitChannelResult {
    code: string;
    msg: string;
    data: any;
}

export const enterQuitChannel = async (
    data: EnterQuitChannelPayload,
): Promise<EnterQuitChannelResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/onlineStatus",
        method: "post",
        data,
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface QueryChannelNumResult {
    code: string;
    msg: string;
    data: string[];
}

export const queryChannelNum = async (channelUUID: string): Promise<QueryChannelNumResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/onlinemembers?channelUuid=" + channelUUID,
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export const queryChannelInfo = async (channelUUID: string): Promise<QueryChannelResultData> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/info?channelUuid=" + channelUUID,
        method: "get",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export const quitAllChannel = async (): Promise<any> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/offline",
        method: "post",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
    });
};

export interface CheckInviteUrlResult {
    code: string;
    msg: string;
    data: false | string;
}

/**
 * 用于校验邀请链接唯一标识是否有效
 * @param {string} channelKey 频道邀请链接的唯一标识
 */
export const checkInviteURL = async (channelKey: string): Promise<CheckInviteUrlResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/invite/get?inviteFlag=" + channelKey,
        method: "get",
    });
};

export interface SetInviteUrlResult {
    code: string;
    msg: string;
    data: string;
}

/**
 * 用于设置邀请链接的过期时间（该接口会在第一次调用时建立一个Redis Key, 7天内过期）
 * @param {string} channelKey 频道邀请链接的唯一标识
 * @param {string} channelUuid 频道Uuid
 */
export const setInviteURLTime = async (
    channelKey: string,
    channelUuid: string,
): Promise<SetInviteUrlResult> => {
    return request({
        url: CHANNEL_SERVER + "/gcms/v1/channel/invite/set",
        method: "post",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
            inviteFlag: channelKey,
            channelUuid: channelUuid,
        },
    });
};
